var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useState } from 'react';
import { filterBrowserEntriesByName, } from '@lucidlink/uicore';
import { useLucidSdk } from '#context';
import { emitDirectorySearchAppliedTelemetry, } from '#telemetry';
export const useBrowserSearch = ({ browserInstance, currentDirId, filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const [state, setState] = useState({
        dirId: currentDirId,
        search: '',
    });
    // A search belongs to the directory it was typed in, so it reads as empty once the user navigates away
    const search = state.dirId === currentDirId ? state.search : '';
    const setSearch = useCallback((nextSearch) => {
        if (search.trim() === '' && nextSearch.trim() !== '') {
            emitDirectorySearchAppliedTelemetry(lucidSdk, {
                browserInstance,
                filespaceId,
                workspaceId,
            });
        }
        setState({ dirId: currentDirId, search: nextSearch });
    }, [
        browserInstance,
        currentDirId,
        filespaceId,
        lucidSdk,
        search,
        workspaceId,
    ]);
    return {
        search,
        setSearch,
        filter: useCallback((currentDirContents) => filterBrowserEntriesByName(currentDirContents, search), [search]),
    };
};
_react_refresh_temp_1(useBrowserSearch, "z/kgfxTU9wLvWp3PE/sTc6ivplY=", false, () => [useLucidSdk]);
